<template>
  <div
    class="border-gray-200 sticky bottom-0 z-50 flex bg-white"
    :class="{
      'flex-col gap-4 p-4 sm:px-0 sm:py-4': isAddToBasketPopover && !isDesktop,
      'flex-col gap-4 p-4 sm:px-0 sm:pb-0 sm:pt-4':
        isAddToBasketPopover && isDesktop,
      'flex-col border-t p-4': !isAddToBasketPopover,
    }"
    @click.capture="$emit('close')"
  >
    <div v-if="isAddToBasketPopover && isDesktop" class="flex w-full">
      <div class="flex w-full gap-4">
        <NuxtLink
          :to="toLocalePath({ name: 'basket' })"
          class="font-semibold flex flex-1 items-center justify-center border border-black bg-white p-2 text-center text-sm uppercase text-black"
          data-qa="show-cart"
          @click.capture="$emit('close')"
          >{{ $t('basket.heading') }}</NuxtLink
        >
        <NuxtLink
          :to="toLocalePath({ name: 'checkout' })"
          class="flex flex-1 items-center justify-center bg-primary p-2 text-center text-sm font-bold uppercase text-white"
          data-qa="go-to-checkout"
          @click.capture="$emit('close')"
          >{{ $t('basket.checkout_label') }}</NuxtLink
        >
      </div>
    </div>
    <div
      v-if="isAddToBasketPopover && !isDesktop"
      class="flex w-full flex-col gap-4"
    >
      <div class="flex w-full gap-4">
        <NuxtLink
          :to="toLocalePath({ name: 'basket' })"
          class="font-semibold flex flex-1 items-center justify-center border border-black bg-white p-2 text-center text-sm uppercase text-black"
          data-qa="show-cart"
          @click.capture="$emit('close')"
          >{{ $t('basket.heading') }}</NuxtLink
        >
        <NuxtLink
          :to="toLocalePath({ name: 'checkout' })"
          class="flex flex-1 items-center justify-center bg-primary p-2 text-center text-sm font-bold uppercase text-white"
          data-qa="go-to-checkout"
          @click.capture="$emit('close')"
          >{{ $t('basket.checkout_label') }}</NuxtLink
        >
      </div>
      <div class="flex justify-center">
        <button
          class="cursor-pointer text-sm text-black underline hover:no-underline"
          data-qa="continue-shopping"
          @click.capture="$emit('close')"
        >
          {{ $t('basket.continue_shopping_label') }}
        </button>
      </div>
    </div>
    <template v-if="!isAddToBasketPopover">
      <NuxtLink
        :to="toLocalePath({ name: 'checkout' })"
        class="w-full bg-primary p-2 text-center text-sm font-bold uppercase text-white"
        data-qa="go-to-checkout"
        >{{ $t('basket.checkout_label') }}</NuxtLink
      >
      <NuxtLink
        :to="toLocalePath({ name: 'basket' })"
        class="mt-4 flex w-full items-center justify-center border border-black bg-white p-2 text-center text-sm uppercase text-black"
        data-qa="show-cart"
        >{{ $t('basket.heading') }}</NuxtLink
      >
    </template>
  </div>
</template>

<script setup lang="ts">
import useRouteHelpers from '#layers/base/composables/useRouteHelpers'

defineProps({
  isAddToBasketPopover: Boolean,
  isDesktop: Boolean,
})
const { toLocalePath } = useRouteHelpers()

defineEmits(['close'])
</script>
